module.exports = __webpack_public_path__ + "static/media/streeteasy-logo.ecd3ab16.svg";